import Link from '@jetbrains/ring-ui/dist/link/link'

import { Error } from '../Error/Error'

const mail = 'qodana-support@jetbrains.com'

export const NoRightsError = () => {
	return (
		<Error
			title={'😯 Oops, no rights to access'}
			content={
				<div>
					You don't have rights to access.
					<br />
					Please contact your organization administrator or write to{' '}
					<Link href={`mailto:${mail}`}>{mail}</Link>
				</div>
			}
		/>
	)
}
